import React from "react";
import "./styles.css";
import { Grid } from "@material-ui/core";
import {
  TextInput,
  DatePicker,
  AutoCompleteInput,
  PercentInput,
  IntegerInput,
  MoneyInput,
  DecimalInput
} from "components/Global/FormikMaterial";

import { fieldTypes } from "../../../../constants";

const Title = ({ title }) => <div className="harness-form-title">{title}</div>;

/*
 * If a form has a body that contains a section title and form fields, the shape expected is like this:
 *  const example = [
 *      {
 *          sectionTitle: 'Title of the Section',
 *          fields: [
 *              {
 *                  fieldKeyOne: valueOne,
 *                  fieldKeyTwo: valueTwo,
 *                  ...
 *              }
 *          ]
 *      }
 *  ]
 */

const SectionedFieldBody = ({ sections }) => (
  <>
    {sections?.map(({ sectionTitle, fields }, idx) => (
      <Grid container item xs={12} key={idx}>
        <Grid container item xs={12}>
          <div className="harness-form-section-title">{sectionTitle}</div>
        </Grid>
        {renderFields(fields)}
      </Grid>
    ))}
  </>
);

const renderFields = fieldsArray => (
    fieldsArray?.map((field, idx) => {
      if (field.hidden) {
        return <Grid item lg={3} md={6} xs={12} key={idx} style={{ display: "none" }} />;
      }

      switch (field.fieldType) {
        case fieldTypes.DECIMAL_INPUT:
          return (displayField(<DecimalInput {...field} key={idx} />));
        case fieldTypes.MONEY_INPUT:
          return (displayField(<MoneyInput {...field} key={idx} />));
        case fieldTypes.PERCENT_INPUT:
          return (displayField(<PercentInput {...field} key={idx} />));
        case fieldTypes.AUTOCOMPLETE_INPUT:
          return (displayField(<AutoCompleteInput {...field} key={idx} />));
        case fieldTypes.INTEGER_INPUT:
          return (displayField(<IntegerInput {...field} key={idx} />));
        case fieldTypes.DATE_PICKER:
          return (displayField(<DatePicker {...field} key={idx} />));
        case fieldTypes.TEXT_INPUT:
        default:
          return (displayField(<TextInput {...field} key={idx} />));
      }
    })
);

const displayField = props => <Grid item lg={3} md={6} xs={12} key={props.key}>{props}</Grid>;

const HarnessForm = ({ sections, fields, title }) => (
  <div className="harness-form-wrapper">
    <Grid container alignItems="center" spacing={8}>
      <Grid item xs={12}><Title title={title} /></Grid>
      <Grid item container>
        {sections ? <SectionedFieldBody sections={sections} /> : renderFields(fields)}
      </Grid>
    </Grid>
  </div>
);

export default HarnessForm;
